import React from 'react';
import TextAndMedia from '../TextAndMedia';
import Container from 'components/Container';
import CertificatesGallery from '../CertificatesGallery';
import ContentCarousel from '../ContentCarousel';
import Gallery from '../Gallery';

interface GenericContentProps {
  content?: any[];
}

const GenericContent = ({ content }: GenericContentProps) => {
  if (!content || !Array.isArray(content)) {
    return null;
  }

  return (
    <div>
      {content.map((section, index) => {
        const componentName = section?.__component;

        if (componentName === 'content.carousel') {
          return (
            <Container key={section.id}>
              <ContentCarousel key={section.id} section={section} />
            </Container>
          );
        }

        if (componentName === 'content.text-and-media') {
          return (
            <Container key={section.id}>
              <TextAndMedia key={section.id} section={section} />
            </Container>
          );
        }

        if (componentName === 'content.certificates') {
          return (
            <Container key={section.id}>
              <CertificatesGallery key={section.id} section={section} />
            </Container>
          );
        }

        if (componentName === 'content.gallery') {
          return (
            <Container key={section.id}>
              <Gallery key={section.id} section={section} />
            </Container>
          );
        }
        return null;
      })}
    </div>
  );
};

export default GenericContent;
